// extracted by mini-css-extract-plugin
module.exports = {"Logo":"KodeLogo_Logo__27wMZ"};